import React, { useEffect, useState } from "react";
import LandingJazzCash from "../pages/LandingJazzCash";
import { fetchApiGet, fetchApiPost } from "../utils/FetchApi";
import { ApiName } from "../utils/ApiName";
import { setCookie } from "../utils/CommonFunction";
import tagManagerEvents, {
  tagManagerEventsWithoutParameter,
} from "../utils/GoogleTagManager";

type Props = {
  token: string | null;
};

const LandingJazzCashScreen = (props: Props) => {
  const [phoneNo, setPhoneNo] = useState("");
  const [error, setError] = useState("");
  const [isCheckRadioBtn, setIsCheckRadioBtn] = useState(true);
  const [isHe, setIsHe] = useState(false);
  const [isEnc, setIsEnc] = useState(false);
  const [isLoader, setIsLoader] = useState(false);

  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const utmSource: any = searchParams.get("utm_source");

  const parameter = searchParams.get("parameter") ?? "";
  const utm_campaign = searchParams.get("utm_campaign") ?? "";
  let enc_msisdn: any = searchParams.get("enc_msisdn")
    ? searchParams.get("enc_msisdn")
    : "";

  useEffect(() => {
    if (props.token) {
      if (utmSource) {
        if (
          utmSource === "jazzT" ||
          utmSource === "jazzG" ||
          utmSource === "jazzM"
        ) {
          tagManagerEventsWithoutParameter("Jazz_Traffic");
        } else if (utmSource === "econT") {
          tagManagerEventsWithoutParameter("Econ_Traffic");
        } else {
          tagManagerEventsWithoutParameter("Other_Traffic");
        }
      } else {
        tagManagerEventsWithoutParameter("Other_Traffic");
      }
      if (enc_msisdn) {
        decryptMsisdn(enc_msisdn);
      } else {
        setTimeout(() => {
          getFlow();
        }, 500);
      }
    }
  }, [props.token]);

  const setUtmInCookies = (utmSource: string, msisdn: string) => {
    console.log("utmSource ::", utmSource);
    setCookie(utmSource, msisdn);
  };

  const getFlow = async () => {
    try {
      let data = {
        utm_source: utmSource,
      };
      let response = await fetchApiPost(props.token, ApiName.getFlow, data);
      if (response.status === 0) {
        let phoneNumber = response.response.msisdn.slice(-10);
        setPhoneNo(phoneNumber);
        if (phoneNumber) {
          setIsHe(true);
          setIsCheckRadioBtn(true);
          tagManagerEvents("Number_Punched", utmSource);
          checkUserSubscriptions(phoneNumber);
        } else {
          setIsHe(false);
        }
      }
    } catch (error) {
      console.log("handleGetFlow Error: ", error);
    }
  };

  const handlePhoneNoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    if (!value || (value.length <= 10 && value.match(/^3\d{0,9}$/))) {
      setError("");
      setPhoneNo(e.target.value);
      if (e.target.value.length === 10) {
        tagManagerEvents("Number_Punched", utmSource);
      }
    }
  };

  const handleNavigation = (phoneNumber: string) => {
    if (phoneNumber.length === 10 && isCheckRadioBtn) {
      setUtmInCookies(utmSource, phoneNumber);

      setTimeout(() => {
        window.location.replace(
          `https://subscribe.tamashaweb.com/api/link-wallet-initialize?msisdn=${phoneNumber}&package_id=3&utm_source=${utmSource}&sub_source=${parameter}`,
        );
      }, 500);
    } else if (phoneNumber.length != 10) {
      setError("Please enter a valid 10-digit number");
    } else {
      setError("Please agree to the Terms of Use and Privacy Policy");
    }
  };

  const decryptMsisdn = async (enc: string) => {
    try {
      let data = {
        enc_msisdn: enc,
      };
      let response = await fetchApiPost(props.token, ApiName.decrypt, data);
      console.log("decrypt response:", response);
      if (response.code === 0) {
        let phoneNumber = response.message.slice(-10);
        setPhoneNo(phoneNumber);
        setIsEnc(true);
      }
    } catch (err) {
      setError("Something went wrong, Please try again.");
    }
  };

  const checkUserSubscriptions = async (phoneNumber: string) => {
    try {
      setIsLoader(true);

      let data = {
        msisdn: phoneNumber,
      };
      let response = await fetchApiPost(
        props.token,
        ApiName.checkUserSubscriptions,
        data,
      );

      if (!response.isSubscribed) {
        tagManagerEvents("Proceed_Button_Click", utmSource);
        setTimeout(() => {
          setIsHe(false);
        }, 1000);
        handleNavigation(phoneNumber);
      } else {
        setError("This number is already subscribed.");
      }
    } catch (err) {
      setError("Something went wrong, Please try again.");
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <>
      <LandingJazzCash
        isHe={isHe}
        isEnc={isEnc}
        phoneNo={phoneNo}
        handlePhoneNoChange={handlePhoneNoChange}
        error={error}
        checkUserSubscriptions={checkUserSubscriptions}
        isCheckRadioBtn={isCheckRadioBtn}
        setIsCheckRadioBtn={setIsCheckRadioBtn}
        setError={setError}
        parameter={parameter}
        utm_campaign={utm_campaign}
        isLoader={isLoader}
      />
    </>
  );
};

export default LandingJazzCashScreen;
